import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import './styles.css';

// import required modules
import { Autoplay } from "swiper/modules";

export default function Swipercard(props) {
  const { users } = props;
  return (
    <>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
       
        loop={true}
        grabCursor={true}
        modules={[Autoplay]}
        className="mySwiper"
      >
        {users?.qualifications?.length > 0 &&
          users?.qualifications.map((e) => (
            <SwiperSlide>
              <a
                href={e.qualification}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={e.qualification}
                  className="w-100 rounded-2"
                  // style={{ height: "56vh" }}
                  alt={users?.fname}
                  srcset=""
                />
              </a>
            </SwiperSlide>
          ))}
      </Swiper>
    </>
  );
}
